import { createFilterOptions } from '@material-ui/lab'

export const normalizeString = str =>
  str
    ?.toLowerCase()
    .normalize('NFD') // remove accents
    .replace(/[\u0300-\u036f]/g, '') // remove diacritics
    .replace(/[^\w\s]/gi, '') // remove punctuation (termasuk koma)
    .trim()

export const filterOptions = createFilterOptions({
  stringify: option => normalizeString(option.name),
  trim: true,
  matchFrom: 'any',
})
